import { getPhoneNumberWithCountryCode } from "../../theme/default/modernized/modernized-phone-input";

const modernizedPhoneNumber = {
  update: (field, appData) => {
    const calculatedValue = appData.values[field.name];
    const fieldsArray = appData.screenValidation.fields;
    const index = fieldsArray.findIndex(
      fieldItem => fieldItem.fieldName === field.name
    );
    const fieldObject = {
      fieldName: field.name,
      isValid: modernizedPhoneNumber.validate(
        field,
        calculatedValue,
        appData,
        fieldsArray
      ).isValid,
      isRequired: modernizedPhoneNumber.isRequired(field),
      errorMessage: modernizedPhoneNumber.validate(
        field,
        calculatedValue,
        appData,
        fieldsArray
      ).message,
      value: calculatedValue,
      title: field.title
    };
    if (index > -1) {
      fieldsArray[index] = fieldObject;
    } else {
      fieldsArray.push(fieldObject);
    }
    return fieldObject;
  },

  validate: (
    field,
    value,
    { validators, unmasks, settings, brandCountryCode, isUnifiedRegistration },
    fieldsArray
  ) => {
    const extractedValue =
      value instanceof Object
        ? value.phoneNumber
          ? getPhoneNumberWithCountryCode(value)
          : value.value
        : value;

    if (!extractedValue && !field.required) {
      return {
        isValid: true,
        message: null
      };
    }

    const result = Object.values(validators)
      .map(validator => ({
        ...validator.validate({
          field,
          value: extractedValue,
          fieldsArray,
          unmasks,
          settings,
          brandCountryCode,
          isUnifiedRegistration
        })
      }))
      .find(validator => !validator.isValid);
    return (
      result || {
        isValid: true,
        message: null
      }
    );
  },

  isRequired: field => field.required
};

export default modernizedPhoneNumber;
